import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M0 0H3.13477C3.9668 0 4.64844 0.160156 5.17969 0.480469C5.71484 0.796875 6.10938 1.25195 6.36328 1.8457C6.62109 2.43555 6.75 3.14258 6.75 3.9668C6.75 4.79492 6.61914 5.51172 6.35742 6.11719C6.09961 6.72266 5.70312 7.1875 5.16797 7.51172C4.63672 7.83594 3.95898 7.99805 3.13477 7.99805H0V0ZM1.92773 1.52344V6.46875H2.83008C3.16992 6.46875 3.46289 6.41797 3.70898 6.31641C3.95508 6.21484 4.15625 6.0625 4.3125 5.85938C4.46875 5.65625 4.58398 5.40039 4.6582 5.0918C4.73633 4.7832 4.77539 4.42383 4.77539 4.01367C4.77539 3.4668 4.70703 3.00781 4.57031 2.63672C4.4375 2.26562 4.22656 1.98828 3.9375 1.80469C3.65234 1.61719 3.2832 1.52344 2.83008 1.52344H1.92773Z"
          fill="currentColor"
          transform="translate(27, 29) scale(4)"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
